// src/composables/useMensaje.js
import { reactive } from "vue";

const mensaje = reactive({
  ver: false,
  contenido: "",
  color: "success",
  conTimeOut: true
});

function crearMensaje(contenido, color = "success", conTimeOut = true) {
  mensaje.ver = true;
  mensaje.contenido = contenido;
  mensaje.color = color;
  mensaje.conTimeOut = conTimeOut;
}

export function useMensaje() {
  return { mensaje, crearMensaje };
}
